import React, { useEffect } from 'react'
import ProjectList from './ProjectList'
import { useGetProjectsQuery } from '../features/project/projectApi'
import { useDispatch } from 'react-redux'
import { setInitialValue } from '../features/filter/filterSlice'

export default function ProjectsList() {
    const dispatch = useDispatch()
    const { isLoading, isSuccess, data: projects, isError, error } = useGetProjectsQuery()


    useEffect(() => {
        if (isSuccess) {
            const projectsArray = projects.map(project => project.projectName)
            dispatch(setInitialValue(projectsArray))
        }
    }, [dispatch, isSuccess, projects])



    let content = "";

    if (isLoading) {
        content = "Loading..."
    } else if (!isLoading && isSuccess && projects?.length > 0) {
        content = projects.map(project => <ProjectList key={project.id} project={project} />)
    } else if (!isLoading && isSuccess && projects?.length === 0) {
        content = "No task here."
    } else if (!isLoading && isError) {
        content = error?.message
    }
    return (
        <div>
            <h3 className="text-xl font-bold">Projects</h3>
            <div className="mt-3 space-y-4">
                {content}
            </div>
        </div>
    )
}
